import { TextField, Text } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { userStatuses } from "../../../enums";
import { times } from "../../../enums/times";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import {
  AdminSensorType,
  FShift,
  Shift,
  UserCompact,
} from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";

const AddSensor = () => {
  const [sensors, setSensors] = useOutletContext<[AdminSensorType[], Function]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      long_name: "",
      short_name: "",
      data_key_name: "",
      chart_type: "",
    },
  });

  const [
    { response: saveResponse, isLoading: saveIsLoading, error: saveError },
    doFetchItemSave,
  ] = useFetch(`/administration/directories/sensor_types`, true);

  const onSubmit = (formData: any) => {
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          long_name: formData.long_name,
          short_name: formData.short_name,
          data_key_name: formData.data_key_name,
          chart_type: formData.chart_type,
        },
      },
    });
    
  };

  const AddSensor = (itemSaveResponse: { data: unknown }) => {
    const newSensorData = itemSaveResponse.data as unknown as AdminSensorType;
    setSensors([...sensors, newSensorData]);
  };

  useEffect(() => {
    if (!saveResponse) return;
    AddSensor(saveResponse);
    reset();
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">
          {t("adding_equipment_device_sensor")}
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            {errors ? <ErrorsBlock errors={errors} /> : ""}
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("name")}*`} />
                </div>
              )}
            />
            <Controller
              name="long_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("long_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="short_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("short_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="data_key_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("data_key_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="chart_type"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("chart_type")}*`} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddSensor;
